import { LayoutDashboard, Users, Dumbbell, Calendar } from "lucide-react";

const NAV_ITEMS = [
  { id: "overview", label: "Overview", icon: LayoutDashboard },
  { id: "members", label: "Members", icon: Users },
  { id: "programs", label: "Programs", icon: Dumbbell },
  { id: "sessions", label: "Sessions", icon: Calendar },
];

export default function AdminBottomNav({ activeSection, onSelectSection }) {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-[#030A17]/95 backdrop-blur-md border-t border-white/10 px-2 py-1.5 pb-[calc(0.5rem+env(safe-area-inset-bottom))]"
      aria-label="Admin Navigation"
    >
      <div className="max-w-md mx-auto grid grid-cols-4 gap-1">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = activeSection === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelectSection(item.id)}
              className={`flex flex-col items-center justify-center py-1.5 px-1 rounded-xl transition-all duration-200 cursor-pointer ${
                isActive
                  ? "bg-sky-500/15 text-sky-400 font-semibold"
                  : "text-slate-400 hover:text-slate-200 active:scale-95"
              }`}
              data-testid={`admin-nav-${item.id}`}
            >
              <div className="relative">
                <Icon
                  className={`w-5 h-5 transition-transform duration-200 ${
                    isActive ? "scale-110 text-sky-400 drop-shadow-[0_0_8px_rgba(56,189,248,0.5)]" : ""
                  }`}
                />
                {isActive && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-sky-400 shadow-[0_0_6px_#38bdf8]" />
                )}
              </div>
              <span
                className={`text-[10px] mt-1 tracking-tight truncate ${
                  isActive ? "text-white font-semibold" : "text-slate-400"
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
